var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin-authorized"},[_c('el-row',{staticClass:"bottom-gutter"},[_c('el-card',{attrs:{"shadow":"hover"}},[_c('p',[_vm._v("此页面需要\n        "),_c('code',[_vm._v("ADMIN")]),_vm._v(" 角色才能访问。\n      ")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }